class UrlSelector extends HTMLElement {
  
	constructor(){
		super();
		this.setupEventListeners();
	}

  setupEventListeners(){
    this.querySelector('select').addEventListener('change', this.onSelectChange.bind(this));
  }

  onSelectChange(e){
    e.preventDefault();
    e.stopPropagation();
    const url = e.target.value;
    if (!url) return;
    window.location.href = e.target.value;
  }

}
customElements.define('url-selector', UrlSelector);

